export default {"src":"/_next/static/media/toaster.b394fb50.svg","height":100,"width":100};